<template>
  <div class="personalized-emails w100">
    <h1 class="bold">
      Win-back: Cancelled past
      <br>
      <span>
        Send personalized emails to users who cancelled in the past
      </span>
    </h1>

    <div class="prompts-group">
      <details class="pointer" v-for="(item, index) in buttons"
               :key="index">
        <summary>Prompt for {{ item.name }} email &nbsp;</summary>
        <textarea
            :value="prompts[item.key]"
            @input="handlePrompt($event, item.key)"
            :placeholder="`${item.name} email prompt`"
        />
        <button class="purple-btn block"
                @click="handlePromptSave(item.key)">
            <span class="spinner" v-if="checkIsSaving(item.key)"/>
            {{checkIsSaving(item.key) ? 'Saving...' : 'Save changes'}}
        </button>
      </details>
    </div>

  </div>
</template>

<script setup>
  import {useStore} from "vuex";
  import {computed} from "vue";

  const {state, dispatch, commit} = useStore();
  dispatch('get_win_back_prompts_v3');

  const prompts = computed(() => state.winBackV3.prompts);
  const buttons = [
    {name: '1st', key: 'prompt1'},
    {name: '2nd', key: 'prompt2'},
    {name: '3rd', key: 'prompt3'},
    {name: '4th', key: 'prompt4'},
    {name: '5th', key: 'prompt5'},
  ];

  function checkIsSaving (key) {
    return state.reqStatus === `saving-${key}`
  }

  function handlePrompt (ev, step) {
    commit('UPDATE_WIN_BACK_PROMPT_V3', {step, value: ev.target.value});
  }

  function handlePromptSave (key) {
    if (checkIsSaving(key)) return
    dispatch('save_win_back_prompts_v3', key)
  }
</script>

<style lang="scss">
  .personalized-emails {
    @media only screen and (min-width: 0) {
      .email {
        width: 450px;
        margin-bottom: 30px;
      }
      .purple-btn {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 48px;
        padding: 0 16px;
        margin-right: 30px;
        flex: 0 0 calc(33.33% - 16px);
        max-width: calc(33.33% - 16px);
      }
      .prompts-group {
        details {
          margin-top: 30px;
          summary {
            color: #ababab;
            font-size: 1.8rem;
            font-weight: 700;
          }
          textarea {
            width: 600px;
            height: 300px;
            margin-top: 30px;
          }
          &:first-child {
            textarea {
              width: 100%;
              height: 200px;
              margin-top: 30px;
            }
          }
          button {
            margin-top: 19px;
          }
        }
      }
      .results {
        width: 100%;
        margin-top: 30px;
        h2 {
          font-weight: 400;
          color: #ababab;
          font-size: 1.8rem;
        }
      }
      .base-modal {
        > div {
          width: 424px;
          padding: 20px 30px;
        }
        p {
          margin-top: 0;
          font-size: 14px;
          font-weight: 500;
          line-height: 20px;
        }
        textarea {
          width: 100%;
          height: 308px;
          margin-top: 30px;
          display: block;
          border-radius: 4px;
          border: 0.5px solid #000000;
        }
        button {
          width: 70px;
          height: 46px;
          margin: 30px auto 0;
          border: none;
          background-color: #7c7c7c;
          color: #fff;
          font-size: 1.4rem;
          font-weight: 700;
          border-radius: 4px;
        }
        .cancel-modal {
          background-color: transparent;
          margin-right: 16px;
          color: #7c7c7c;
        }
      }
    }
  }
</style>